import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Toolbar,
  Tooltip,
  Typography
} from '@mui/material';
import Logo from 'src/minimal-components/logo';
import AccountPopover from 'src/layouts/common/account-popover';
import {useLocation, useNavigate} from 'react-router-dom';
import FormConstants from '@shared/constants/FormConstants';
import React, {useEffect} from 'react';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  LMS_PREVIEW_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  PARAMS_KEY,
  MOVE_TO_TAB,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import {CloseIcon} from 'yet-another-react-lightbox';
import {
  getLMSResultsData,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import {enqueueSnackbar} from '@components/snackbar';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {uniq} from 'lodash';
import {LoadingScreen} from '@components/loading-screen';
import { environment } from '@shared/config/environment';

const PreviewThanksPage = () => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const location = useLocation();
  const {fieldsData} = location.state || {};

  const navigate = useNavigate();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const [fieldsDatavals, setFieldsData] = React.useState<any>();
  //console.log('assessment_question_layout_type_id', fieldsDatavals, fieldsData);
  const [uiFieldsvals, setUiFields] = React.useState();
  const [isLoaded, setIsLoaded] = React.useState(true);
  const [isloading, setIsloading] = React.useState(true);
  const query = useQuery();
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const subSection = query.get('subsection');
  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const fileId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const filetype=EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_TYPE
  );
  const moduleId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_MODULE_ID
  );
  const previewId = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_PREVIEW_ID
  );
  const subModuleName = EncryptUtils.getDecryptedData(
    location?.search,
    MOVE_TO_TAB
  );

  //console.log('previewId', previewId, fileId, moduleId, uniqueId);
  // console.log('fieldsData', fieldsData);
  const onRoleChange = async () => {
    // console.log('onRoleChange1', fileId, moduleId);
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: uniqueId,
      [LMS_TYPE]: lmstype,
      [BASE_UNIQUE_ID]: fileId,
      [LMS_MODULE_ID]: moduleId,
      [BASE_UNIQUE_TYPE]:filetype,
      [LMS_PREVIEW_ID]: previewId,
      [MOVE_TO_TAB]: subModuleName,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest/score?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {}
      }
    );
  };
  const handleClose = async () => {
    if (subModuleName !== 'ModuleMain') {
      const paramsKey = EncryptUtils.setEncryptedParams({
        [BASE_RECORD_ID]: uniqueId,
        [LMS_TYPE]: lmstype,
        [BASE_UNIQUE_ID]: fileId,
        [LMS_MODULE_ID]: moduleId,
        [LMS_IS_ADMIN]: lmsisAdmin
      });
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=Pre_post_learning&subsection=pre_learning_activities`,
        {
          state: {}
        }
      );
    } else {
      // console.log('onRole
      // &section=Pre_post_learning&subsection=pre_learning_activitiesChange1', fileId, moduleId);
      const paramsKey = EncryptUtils.setEncryptedParams({
        [BASE_RECORD_ID]: uniqueId,
        [LMS_TYPE]: lmstype,
        [BASE_UNIQUE_ID]: fileId,
        [BASE_UNIQUE_TYPE]:filetype,
        [LMS_MODULE_ID]: moduleId,
        [LMS_IS_ADMIN]: lmsisAdmin
      });
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/Preview?${PARAMS_KEY}=${paramsKey}`,
        {
          state: {}
        }
      );
    }
  };
  const init = async () => {
    try {
      setIsloading(true);
      const res = await getSearchForm(
        applicationName,
        'module',
        'PreviewQuestions'
      );
      setUiFields(res.searchForm);
      if (res.searchForm) {
        let sqlName;
        let TableName;
        let TableQuestions;
        //console.log('subModuleName', subModuleName);
        switch (subModuleName) {
          case 'pre_learning_activities':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            sqlName = 'PreLearning_sql';
            break;
          case 'post_learning_activities':
            (TableName = 'SettingsPostLearningTestList'),
              (TableQuestions = 'SettingsPostLearningQuestionsStorage');
            sqlName = 'PostLearning_sql';
            break;
          case 'prepost_feedback':
            (TableName = 'SettingsPreLearningTestList'),
              (TableQuestions = 'SettingsPreLearningQuestionsStorage');
            break;
          case 'ModuleMain':
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
          default:
            (TableName = 'ModuleOnlineTestList'),
              (TableQuestions = 'ModuleQuestionsStorage');
            sqlName = 'Module_sql';
            break;
        }
        if (sqlName) {
          const {sqldata} = res.searchForm[sqlName];

          const operations = 'SEARCH';
          const data: any = {
            sql_data: sqldata,
            data: {
              id: fileId,
              ThanksPage: true,
              course_overview_id: uniqueId,
              testId: previewId,
              isAdmin: lmsisAdmin === 'True'
            },
            operation: operations
          };
          const encryptRequestData = EncryptUtils.encryptedData(data);
          const result = await getLMSResultsData(applicationName, 'LMS', {
            tk: encryptRequestData
          });
          if (result.data[0]) {
            const transformedResult = result.data.map((item: any) => {
              return {
                ...item,
                // Parse JSON fields or set them to empty arrays if they are null
                choices: item.choices ? JSON.parse(item.choices) : null,
                correctMatches: item.correctMatches
                  ? JSON.parse(item.correctMatches)
                  : null,
                additionalChoices: item.additionalChoices
                  ? JSON.parse(item.additionalChoices)
                  : null,
                descriptive_enforce_word_limit:
                  item.descriptive_enforce_word_limit
                    ? JSON.parse(item.descriptive_enforce_word_limit)
                        .descriptive_enforce_word_limit
                    : null,
                // Parse the descriptive_enforce_word_limit_length JSON or set it to null
                descriptive_enforce_word_limit_length:
                  item.descriptive_enforce_word_limit_length
                    ? JSON.parse(item.descriptive_enforce_word_limit_length)
                        .descriptive_enforce_word_limit_length
                    : null,
                TrueFalse: item.TrueFalse
                  ? JSON.parse(item.TrueFalse).TrueFalse
                  : null
                // Add any additional transformations here if needed
              };
            });
            //console.log('transformedResult[0]', transformedResult[0]);
            setFieldsData(transformedResult[0]);
          }
        }
        setIsloading(false);
      }
      setIsloading(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      setIsloading(false);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  useEffect(() => {
    // console.log(
    //   'selectedPreviewFile',
    //   fieldsData
    //   // mainContent
    // );
    const fetchData = async () => {
      try {
        //console.log('uniqueId', uniqueId, moduleId, fileId);
        if (!fieldsData) {
          // const res = await getSearchForm(applicationName, 'module');
          // setUiFields(res.searchForm);
          await init();
        } else {
          setFieldsData(fieldsData);
        }
      } catch (error) {
        console.error('error', error);
      }
    };
    if (!fieldsData) {
      //console.log('selectedPreviewFile', fieldsData);
      fetchData();
    } else {
      // setMainContent(ModulePreviewData);
      setFieldsData(fieldsData);
      // setViewedFile(selectedPreviewFile);
      setIsloading(false);
    }
  }, []);
  useEffect(() => {
    // 🔥 Prevent back button navigation
    const handleBackButton = (event: PopStateEvent): void => {
      // console.log('event', event);
      event.preventDefault();
      window.history.pushState(null, '', window.location.href);
      navigate(0);
    };

    window.history.pushState(null, '', window.location.href); // Push current page into history

    window.addEventListener('popstate', handleBackButton); // Listen for back button press

    return () => {
      window.removeEventListener('popstate', handleBackButton); // Cleanup listener on unmount
    };
  }, [navigate]);
  // useEffect(() => {
  //   const handleBackButton = (event: PopStateEvent) => {
  //     event.preventDefault();
  //     window.history.pushState(null, '', window.location.href);
  //     navigate(0); // Reload the page to enforce restriction
  //   };

  //   // Push initial state without adding duplicates
  //   if (window.history.state === null) {
  //     window.history.pushState(null, '', window.location.href);
  //   }

  //   window.addEventListener('popstate', handleBackButton);

  //   return () => {
  //     window.removeEventListener('popstate', handleBackButton);
  //   };
  // }, [navigate]);
  const renderContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
      }}>
      <Logo
        disabledLink={true}
        applicationName={'LMS'}
        sx={{mt: 3, ml: 4, mb: 1}}
      />

      <Box>
                {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED  &&<AccountPopover isDashboard={true} /> }
        <Tooltip title="Close">
          <IconButton onClick={() => handleClose()}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #3a7bd5, #3a6073)',
        color: 'white'
      }}>
      <Toolbar
        sx={{
          height: 1,
          backgroundColor: 'white'
          // px: {lg: 5}
        }}>
        {renderContent}
      </Toolbar>
      {isloading ? (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      ) : (
        <Box sx={{pt: 4}}>
          {/* Header */}
          <Box>
            <Typography
              variant="h5"
              sx={{textAlign: 'center', fontWeight: 'bold', mb: 0.5}}>
              {fieldsDatavals?.name}
            </Typography>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{mb: 1, display: 'flex'}}
              justifyContent={'center'}>
              <Grid item sx={{display: 'flex'}}>
                <Typography variant="subtitle2" sx={{mr: 0.5}}>
                  <strong>Date : </strong>
                </Typography>
                <Typography variant="body1">
                  {fieldsDatavals?.testStartTime
                    ? new Date(fieldsDatavals.testStartTime).toLocaleDateString(
                        'en-GB',
                        {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        }
                      )
                    : 'N/A'}
                </Typography>
              </Grid>
              {/* Dynamically Render Fields */}
              {[
                {
                  label: 'Total Questions : ',
                  value: fieldsDatavals?.TotalQuestions
                },
                {label: 'Total Marks : ', value: fieldsDatavals?.TotalMarks}
              ]
                .filter(
                  field => field.value !== undefined && field.value !== null
                ) // Ensure only valid fields are shown
                .map((field, index) => (
                  <Grid key={index} item sx={{display: 'flex'}}>
                    <Typography variant="subtitle2" sx={{mr: 0.5}}>
                      <strong>{field.label}</strong>
                    </Typography>
                    <Typography variant="body1">{field.value}</Typography>
                  </Grid>
                ))}

              {/* Action Button */}
            </Grid>
          </Box>
          <Paper
            // elevation={3}
            sx={{
              maxWidth: '60vw',
              minHeight: '50vh',
              display: 'flex',
              margin: '0 auto',
              padding: 3,
              borderRadius: '10px'
            }}>
            <Card
              sx={{
                backgroundColor: '#f8f9fa',
                marginTop: 3,
                display: 'flex',
                flex: 1,
                boxShadow:
                  '0px 3px 3px -2px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)',
                borderRadius: '8px'
              }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flex: 1
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    flex: 1,
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                  }}>
                  <Typography>Test Completed!</Typography>
                  <Typography>Thank you for taking the test!</Typography>
                  {(fieldsDatavals?.assessment_show_marks_type_id > 0 || lmsisAdmin === 'True') && (
                    <Box>
                      <Button
                        variant="contained"
                        color="info"
                        onClick={() => onRoleChange()}>
                        View Result
                      </Button>
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Paper>
        </Box>
      )}
    </Box>
  );
};
export default PreviewThanksPage;

